import { dbStore } from '../firebase'
export const GetPrintersHistory = function (vm, historyFilters) {
  console.log('GetPrintersHistory() Started ...')
  console.log(JSON.stringify(historyFilters))
  let result = { Success: false, Data: 'No Started Yet !!' }
  let printersHistory = []
  let promises = []
  const promise = new Promise((resolve, reject) => {
    try {
      loadDataByCustomerFromStorePath(vm, historyFilters, promises)
      Promise.all(promises).then(function (response) {
        response.forEach(function (arr) {
          if (arr && arr.length > 0) {
            printersHistory = printersHistory.concat(arr)
          }
        })
        console.log('printersHistory = ' + printersHistory.length)
        console.log('printersHistory = ' + JSON.stringify(printersHistory))
        result = { Success: true, Data: printersHistory }
        resolve(result)
      }).catch(function (error) {
        console.log('printersHistory = ' + printersHistory.length)
        console.log(`GetPrintersHistory() Error: ${error}`)
        result = { Success: false, Data: error }
        reject(result)
      })
    } catch (generalError) {
      result = { Success: false, Data: generalError }
      reject(result)
    }
  })
  return promise
}

function loadDataByCustomerFromStorePath (vm, historyFilters, promises) {
  console.log('loadDataByCustomerFromStorePath() ...')
  historyFilters.customers.forEach(function (cust) {
    let custKey = cust.value
    let custName = cust.title
    console.log('loadDataByCustomerFromStorePath(' + custName + ' : ' + custKey + ') ...')
    historyFilters.datePaths.forEach(function (dPath) {
      let fromPath = '/PrintersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + custKey + '/' + dPath
      let p = loadDataFromStorePath(vm, fromPath, historyFilters.fromDate, historyFilters.toDate, historyFilters.printerMAC).then(function (data) {
        return Promise.resolve(data)
      }).catch(function (error) {
        console.log('Promise.reject ' + custKey)
        return Promise.reject(custKey, error)
      })
      promises.push(p)
    })
  })
}

function loadDataFromStorePath (vm, path, fromDate, toDate, printerMAC) {
  console.log('loadDataFromStorePath() ...')
  console.log('path = ' + path)
  console.log('fromDate = ' + fromDate)
  console.log('toDate = ' + toDate)
  let printersHistoryRef = ''
  if (printerMAC && printerMAC.length > 0) {
    printersHistoryRef = dbStore.collection(path).where('MacAddress', '==', printerMAC).where('LoggedInt', '>=', fromDate).where('LoggedInt', '<=', toDate)
  } else {
    printersHistoryRef = dbStore.collection(path).where('LoggedInt', '>=', fromDate).where('LoggedInt', '<=', toDate)
  }
  // let printersHistoryRef = dbStore.collection(path)
  return loadDataFromStore(vm, printersHistoryRef, path)
}

function loadDataFromStore (vm, printersHistoryRef, path) {
  // return printersHistoryRef.limit(5000).get().then(function (snapPrinters) {
  return printersHistoryRef.get().then(function (snapPrinters) {
    let arrHistory = []
    console.log('snapPrinters.size = ' + snapPrinters.size)
    if (snapPrinters.size > 0) {
      snapPrinters.forEach(function (result) {
        let printer = result.data()
        printer['DocID'] = result.id
        // printer['Path'] = path + result.id
        printer['Path'] = path
        if (vm.filters.siteKey !== 'All') {
          if (printer.SiteKey !== vm.filters.siteKey) {
            return
          }
        }
        let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
        if (dealer) {
          printer['Dealer'] = dealer.title
        }
        let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
        if (cust) {
          printer['Customer'] = cust.title
        }
        let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
        if (site) {
          printer['Site'] = site.title
        }
        printer.PageCount = parseInt(printer.PageCount, 10)
        printer.A4Black = parseInt(printer.A4Black, 10)
        printer.A4Color = parseInt(printer.A4Color, 10)
        printer.A3Black = parseInt(printer.A3Black, 10)
        printer.A3Color = parseInt(printer.A3Color, 10)
        printer.BlackTonerLeft = parseTonerLeft(printer.BlackTonerLeft, 10)
        printer.CyanTonerLeft = parseTonerLeft(printer.CyanTonerLeft, 10)
        printer.MagentaTonerLeft = parseTonerLeft(printer.MagentaTonerLeft, 10)
        printer.YellowTonerLeft = parseTonerLeft(printer.YellowTonerLeft, 10)
        arrHistory.push(printer)
      })
      arrHistory = arrHistory.slice().sort(function (a, b) {
        return a.LoggedInt < b.LoggedInt ? -1 : 1
      })
    } else {
      console.log('printersHistory NO DATA !!')
      arrHistory = []
    }
    return arrHistory
  }).catch(function (err) {
    console.log(err)
    console.log(err.message)
  })
}

function parseTonerLeft (colorLeft) {
  let colorLeftInt = 0
  if (colorLeft && colorLeft.length > 0) {
    if (colorLeft.indexOf('-') >= 0) {
      colorLeftInt = 0
    }
    colorLeft = colorLeft.replace('%', '')
    colorLeft = colorLeft.split('.')[0]
    colorLeftInt = parseInt(colorLeft, 10)
  } else {
    colorLeftInt = -1
    // colorLeftInt = ''
  }
  // if (colorLeftInt > 100) { colorLeftInt = 100 }
  // if (colorLeftInt < 0) { colorLeftInt = 0 }
  if (isNaN(colorLeftInt)) {
    colorLeftInt = 0
  }
  return colorLeftInt
}



// WEBPACK FOOTER //
// ./src/plugins/printersHistory.js